import plainAxios from "axios";
import axios from "../../lib/axiosInstance";

export function companySignup(payload) {
  return axios.post("auth/signup", payload).then((res) => res.data);
}

export function login(payload) {
  return axios.post("auth/login", payload).then((res) => res.data);
}
export function socialTokenLogin({ idToken, role }) {
  return plainAxios
    .post(`${process.env.REACT_APP_BASE_URL}auth/socialLogin`, { idToken, role })
    .then((res) => res.data);
}

/**
 * The logged-in user in the same shape /auth/login returns — including isFirstLogin
 * and the role's permissions, which useAuth needs. Not the same as users/me, which
 * is a profile read and omits both.
 */
export function session() {
  return axios.get("auth/session").then((res) => res.data?.data);
}

export function connectedAccounts() {
  return axios.get("auth/connectedAccounts").then((res) => res.data?.data ?? []);
}

export function logout(payload) {
  return axios.post("auth/logout", payload).then((res) => res.data);
}

export function verifyOtp(payload) {
  return axios.post(`otps/verify`, payload).then((res) => res.data);
}

export function resendOtpApi(email) {
  console.log(email);
  return axios.get(`otps/resend/${email}`).then((res) => res.data);
}

export function forgotPassword(payload) {
  return axios.post(`/auth/forgotPassword`, payload).then((res) => res.data);
}

export function resetPassword(payload) {
  return axios.put(`/auth/resetPassword`, payload).then((res) => res.data);
}
export function createNewPassword(payload) {
  return axios.put(`/auth/createNewPassword`, payload).then((res) => res.data);
}

export function changePassword(payload) {
  return axios.put(`/auth/changePassword`, payload).then((res) => res.data);
}
